export { default } from "ember-stereo/-private/utils/prepare-options";
